import _, {trim} from 'lodash';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import SummaryView from '@/helpers/summaryView';

export default {
	computed: {
		...mapGetters(['getCalculation']),
		...mapGetters('contracting', ['getSelectedOffer', 'getAllFormData', 'getRiskBearingAddress']),
        ...mapGetters('auth', ['getCurrentUser']),
	},
	methods: {
		...mapMutations(['setStateData']),
		...mapMutations('contracting', ['refreshContractData', 'setDisabledInput', 'setInited', 'setCheckboxData', 'setPermanentAddress']),
		...mapActions('contracting', ['saveNew', 'saveUser']),
		beforeNext() {
			return new Promise(async (resolve, reject) => {
				if (!this.getCheckboxData('differentPermanentAddress')) {
					_.each(this.fields.permanentAddress, field => {
						this.setFormData({
							parent: field.input.parent,
							group: field.input.group,
							prop: field.input.prop,
							value: this.getFormData({
								parent: field.input.parent,
								group: 'riskBearingAddress',
								prop: field.input.prop,
							}),
						});
					});
				}

				if (!this.getCheckboxData('differentMailingAddress')) {
					_.each(this.fields.mailingAddress, field => {
						this.setFormData({
							parent: field.input.parent,
							group: field.input.group,
							prop: field.input.prop,
							value: this.getFormData({
								parent: field.input.parent,
								group: 'permanentAddress',
								prop: field.input.prop,
							}),
						});
					});
				}

                if(typeof this.beforePrevAfter !== "undefined") {
                    this.beforePrevAfter();
                }

				const summaryView = new SummaryView(
					this.getCalculation,
					this.getSelectedOffer,
					this.getAllFormData,
					this.$store,
				);

				const saved = await this.saveNew({ dataKey: 'baseData', summaryView: summaryView.getData() });

				const saveUserData = await this.saveUser({
					mother_name: this.getAllFormData.baseData.contractDetails.mother_name,
					gender: this.getAllFormData.baseData.contractDetails.gender,
					birth_place: this.getAllFormData.baseData.contractDetails.birth_city,
					birth_date: this.getAllFormData.baseData.contractDetails.birth_date,
                    birth_name: this.getAllFormData.baseData.contractDetails.birth_name,
					bank_name: this.getAllFormData.baseData?.paymentDetails?.bank_name ?? null,
					bank_account_number: this.getAllFormData.baseData?.paymentDetails?.bank_account_number ?? null,
                    landline: this.getAllFormData.baseData.contractDetails.phone_number ?? null,
                    phone: this.getAllFormData.baseData.contractDetails.mobile_number ?? null,
                    forename: this.getAllFormData.baseData.contractDetails.forename ?? null,
                    permanentAddress: this.getAllFormData.baseData.permanentAddress ?? null,
				});

				if (saved) {
					if (this.getCheckboxData('differentInsuredData') || this.getSelectedOffer.insurer_code === 'GEN') {
						resolve({ success: true, routeTo: 'contracting-insured' });
					}

					if (this.getCalculation.real_estate.mortgage) {
						resolve({ success: true, routeTo: 'contracting-financing' });
					}

					resolve({ success: true, routeTo: 'contracting-summary' });
				}
			});
		},
		beforePrev() {
			return new Promise((resolve, reject) => {
				this.refreshContractData();
				this.setInited(false);
				resolve({ success: true, routeTo: 'comparison' });
			});
		},
		async init() {
			const address = this.getCalculation.real_estate.address.split(' ');
			const addressType = address.length === 1 ? null : address[address.length - 1];
			const addressName = this.getCalculation.real_estate.address.replace(addressType, '');

			const preloadData = [
				{ group: 'contractDetails', prop: 'last_name', value: this.getCalculation.user.last_name ?? null },
				{ group: 'contractDetails', prop: 'first_name', value: this.getCalculation.user.first_name ?? null },
				{
					group: 'contractDetails',
					prop: 'birth_name',
					value: this.getCalculation.user ? this.getCalculation.user.birth_name : null,
				},
				{
					group: 'contractDetails',
					prop: 'email',
					value: this.getCalculation.user ? this.getCalculation.user.email : null,
				},
				{
					group: 'contractDetails',
					prop: 'mobile_number',
					value: this.getCalculation.user ? this.getCalculation.user.phone : null,
				},
                {
                    group: 'contractDetails',
                    prop: 'phone_number',
                    value: this.getCalculation.user ? this.getCalculation.user.landline : null,
                },
				{
					group: 'contractDetails',
					prop: 'birth_date',
					value: this.getCalculation.user ? this.getCalculation.user.birth_date : null,
				},
				{
					group: 'contractDetails',
					prop: 'mother_name',
					value: this.getCalculation.user ? this.getCalculation.user.mother_name : null,
				},
				{
					group: 'contractDetails',
					prop: 'gender',
					value: this.getCalculation.user ? this.getCalculation.user.gender : null,
				},
				{
					group: 'contractDetails',
					prop: 'birth_city',
					value: this.getCalculation.user ? this.getCalculation.user.birth_place : null,
				},
				{
					group: 'paymentDetails',
					prop: 'bank_name',
					value: this.getCalculation.user ? this.getCalculation.user.bank_name : null,
				},
				{
					group: 'paymentDetails',
					prop: 'bank_account_number',
					value: this.getCalculation.user ? this.getCalculation.user.bank_account_number : null,
				},
				{
					group: 'riskBearingAddress',
					prop: 'postal_code',
					value: this.getCalculation.real_estate.postal_code ?? null,
				},
				{ group: 'riskBearingAddress', prop: 'city', value: this.getCalculation.real_estate.city ?? null },
				{ group: 'riskBearingAddress', prop: 'address_name', value: addressName ?? null },
				{ group: 'riskBearingAddress', prop: 'address_type', value: addressType ?? null },
				{
					group: 'riskBearingAddress',
					prop: 'from_house_number',
					value: this.getCalculation.real_estate.house_number ?? null,
				},
				{
					group: 'riskBearingAddress',
					prop: 'parcel_number',
					value: this.getCalculation.real_estate.parcel_number ?? null,
				},
				{
					group: 'riskBearingAddress',
					prop: 'to_house_number',
					value: this.getCalculation.real_estate.house_number_to ?? null,
				},
				{
					group: 'riskBearingAddress',
					prop: 'building',
					value: this.getCalculation.real_estate.building ?? null,
				},
				{
					group: 'riskBearingAddress',
					prop: 'stairway',
					value: this.getCalculation.real_estate.stairway ?? null,
				},
				{ group: 'riskBearingAddress', prop: 'floor', value: this.getCalculation.real_estate.floor ?? null },
				{ group: 'riskBearingAddress', prop: 'door', value: this.getCalculation.real_estate.door ?? null },
			];

			this.setStateData({
				prop: 'hasParcelNumber',
				value: this.getCalculation.real_estate.parcel_number !== null,
			});

			return new Promise((resolve, reject) => {
				const lockedFields = [
					'gender',
					'last_name',
					'first_name',
					'email',
					'birth_date',
					'birth_city',
					'mother_name',
                    'birth_name',
				];

				_.each(preloadData, field => {
					const value =
						this.getFormData({ parent: 'baseData', group: field.group, prop: field.prop }) ?? field.value;

					this.setFormData({
						parent: 'baseData',
						group: field.group,
						prop: field.prop,
						value,
					});

					if (lockedFields.includes(field.prop) && value !== null) {
						this.setDisabledInput(`baseData-${field.group}-${field.prop}`);
					}
				});

                if (this.getCurrentUser?.permanent_address && this.getRiskBearingAddress) {
                    const compareParams = [
                        "postal_code",
                        "city",
                        "address_name",
                        "address_type",
                        "from_house_number",
                        "parcel_number",
                        "to_house_number",
                        "building",
                        "stairway",
                        "floor",
                        "door",
                    ];
                    let differentAddress = false;
                    compareParams.forEach(param => {
                            if (trim(this.getRiskBearingAddress[param]) !== trim(this.getCurrentUser.permanent_address[param])){
                                differentAddress = true;
                            }
                        }
                    );

                    if (differentAddress) {
                        this.setCheckboxData({
                            prop: 'differentPermanentAddress',
                            value: true,
                        });
                        this.setPermanentAddress(this.getCurrentUser.permanent_address);
                    }
                }

				resolve(true);
			});
		},
	},
};
